module.exports = __webpack_public_path__ + "media/honey-icons/icon-hub-360-746cbb50.svg";